import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogCardMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSecFirstCard.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSecSecondCard.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blogImages/blueCardBottomVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blogImages/blueCardTopVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blogImages/eventCardImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/common/purplePurpleIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/EventHeroImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/eventHeroImageMobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/EventHeroImageOpacity.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/firstVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/firstVectorMobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/fourthVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/manPouringDrink.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/peopleHandShaking.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/secondVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/secondVectorMobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/thirdVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/thirdVectorMobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/threeManWithFood.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/threeMenSmiling.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/twoMenOneWomen.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/twoMenWithFlowers.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/event/twoWomenWithChild.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Food.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Icons/pilResurs13303.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Icons/PurpleNextArrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Icons/PurplePreviousArrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/manInCoat.jpg");
